import { combineReducers, configureStore } from '@reduxjs/toolkit';
import globalSlice from './global-slice';
import internalSlice from './internal-slice';

const rootReducer = combineReducers({
  global: globalSlice.reducer,
  internal: internalSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default function configureAppStore() {
  return configureStore({
    reducer: rootReducer,
  });
}
